import React from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import ButtonGroup from '@teetsh/app/src/components/Form/ButtonGroup';
import {
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
} from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { useEvaluationUndoRedo } from '../queries/evaluations/useEvaluationUndoRedo';

interface Props {
  large?: boolean;
  minimal?: boolean;
  carnetDeNotesId: string;
  evaluationId: string;
}

export function UndoRedo(props: Props) {
  const { large, minimal, evaluationId, carnetDeNotesId } = props;
  const { handleUndo, handleRedo, canUndo, canRedo } = useEvaluationUndoRedo(
    carnetDeNotesId,
    evaluationId,
  );

  const { t } = useTranslation(['common']);

  return (
    <ButtonGroup>
      <Button
        title={t('common:buttons.undo')}
        aria-label="Revenir en arrière"
        large={large}
        minimal={minimal}
        disabled={!canUndo}
        onClick={() => handleUndo()}
        icon={ArrowUturnLeftIcon}
      />
      <Button
        aria-label="Revenir en avant"
        title={t('common:buttons.redo')}
        disabled={!canRedo}
        large={large}
        minimal={minimal}
        onClick={() => handleRedo()}
        icon={ArrowUturnRightIcon}
      />
    </ButtonGroup>
  );
}
